<template>
  <div class="block-sh">
    <div class="block-sh__letter letter letter-red" data-aos="fade-up">Ш.</div>
    <div class="block-sh__image" data-aos="fade-up"><img src="../assets/img/block-sh-m-1.png" alt=""></div>
    <div class="block-sh__title" data-aos="fade-up">
      Шпион
    </div>
    <div class="block-sh__text" data-aos="fade-up">Как многие артисты, композиторы, поэты и певцы того времени, Вертинский в свободное от работы время успевал быть ещё и шпионом (конечно же, с точки зрения властей). Заработать такую репутацию ему оказалось несложно: в период, когда он гастролировал по Бессарабии (в то время территория Румынии), Вертинский по какой-то причине отказался участвовать<br>в бенефисе некой кишинёвской актрисы, являвшейся любовницей местного генерала. </div>
    <div class="block-sh__result" data-aos="fade-up">
      <i class="block-sh__result-i block-sh__result-i--1"></i>
      <i class="block-sh__result-i block-sh__result-i--2"></i>
      <p>
      Результат не заставил себя ждать. <br>
      <span>Вертинский был обвинён в шпионаже</span><br>в пользу СССР, а также «разжигание <br>антирумынских настроений» и был <br>депортирован в Бухарест.</p>
    </div>

  </div>
</template>

<script>
export default {
  name: 'BlockF'
}
</script>

<style lang="sass">
  @media screen and (max-width: 999px)
    .block-sh__result
      width: 100vw
      margin-left: 0
      height: vwm(192px)
      margin-top: vwm(40px)
      overflow: hidden
      &-i
        width: vwm(13px)
        height: vwm(13px)
        top: vwm(6px)
        left: vwm(6px)
        &:before
          left: vwm(-8px)
          width: vwm(22px)
          height: vwm(1px)
        &--2
          top: auto
          left: auto
          bottom: vwm(6px)
          right: vwm(6px)
      p
        font-size: vwm(18px)
        line-height: vwm(22px)
    .block-sh__text
      font-size: vwm(17px)
      line-height: vwm(23px)
      width: 90vw
      margin-top: vwm(52px)
      margin-left: vwm(19px)
      text-align: left
      br
        display: none
    .block-sh__image
      width: 100vw
      margin-top: -54vw
      position: relative
      z-index: 10
      &:before
        display: none !important
      &:after
        display: none !important
    .block-sh__title
      font-size: vwm(60px)
      margin-left: vwm(18px)
      margin-top: vwm(-40px)
    .block-sh__letter
      position: relative
      z-index: 20
      margin-top: vwm(75px)
      margin-left: vwm(12px)
</style>
